import * as types from './types'

export default {
  [types.MUTATE_SERIES_TYPES]: (state, payload) => {
    state.types = (payload || []).map((item) => ({ ...item, value: item.key }))
  },
  [types.MUTATE_SERIES_REPETITION_TYPES]: (state, payload) => {
    state.repetitionsTypes = (payload || []).map((item) => ({ ...item, value: item.key }))
  },
  [types.MUTATE_SERIES_MONTHLY_REPETITION_TYPES]: (state, payload) => {
    state.monthlyRepetitionTypes = (payload || []).map((item) => ({ ...item, value: item.key }))
  },
  [types.MUTATE_DUTY_VALUE_SOURCE_TYPES]: (state, payload) => {
    state.dutyValueSources = (payload || []).map((item) => ({ ...item, value: item.key }))
  },
  [types.MUTATE_SERIES_SEARCH_RESULTS]: (state, payload) => {
    state.searchResults = payload || {}
  }
}
